<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">订单[{{ this.OrdersSN }}]{{ this.status == 1 ? '批量免盖章' : '批量取消免盖章' }}</div>
            <div class="mb20" v-for="(item, index) in list" :key="index">
                <div v-if="item.Message" class="error">[{{ item.Orders_SN }}]: {{ item.Message }}</div>
                <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label" v-else>
                    <el-descriptions-item label="订单号">
                        <div class="rows">{{ item.Orders_SN }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="订单类型">
                        <div class="rows">{{ item.DiscountCateName }}</div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>

            <div class="button-container">
                <el-button type="primary" v-if="relate_orders.length > 0" @click="submit">提交</el-button>
                <el-button type="primary" @click="goBack">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orderOperate: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            list: [],
            OrdersID: '',
            OrdersSN: '', //合同SN
            OrdersAuditStatus: '', //合同审核状态
            batchId: '',
            relate_orders: [],
            status: ''
        };
    },
    mounted() {
        if (this.orderOperate) {
            this.OrdersID = this.orderOperate.OrdersID;
            this.OrdersSN = this.orderOperate.OrdersSN;
            this.OrdersAuditStatus = this.orderOperate.OrdersAuditStatus;
            this.batchId = this.orderOperate.batchId;
            this.status = this.orderOperate.status;
            this.CheckSPCOrdersBatchWaitsign();
        }
    },
    methods: {
        async CheckSPCOrdersBatchWaitsign() {
            let result = await this.$newsApi.order.CheckSPCOrdersBatchWaitsign({
                OrdersID: this.OrdersID,
                relate_orders: this.batchId,
                Status: this.status
            });
            let data = result.data.data;
            this.relate_orders = data.filter((item) => !item.Message).map((item) => item.Orders_ID);
            this.list = data;
        },
        goBack() {
            // this.$router.push({
            //     path: '/orderManagement/contractmanagementDetails',
            //     query: {
            //         id: this.OrdersID
            //     }
            // });
            this.$emit('BatchInvoiceRes', false);
        },
        async submit() {
            let data = this.relate_orders.join();
            let result = await this.$newsApi.order.SPCOrders_NoSignBatch({
                OrdersID: this.OrdersID,
                relate_orders: data,
                Status: this.status
            });
            if (result.data.Resultcode == 0) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                // this.$router.go(-1);
                this.$emit('BatchInvoiceRes', false);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
/* 禁用所有滚动条 */
.content,
.hw-content,
.content * {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}
.content,
.hw-content
 {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

/* 禁用弹窗滚动条 */
::v-deep .el-dialog {
    overflow: hidden !important;
   overflow-y: hidden !important;
}

::v-deep .el-dialog__body {
    overflow: hidden !important;
    overflow-y: hidden !important;
}
</style>